import AxiosInstance from "./AxiosInstance";

export const getAllPrefferPartner = async () => {
  try {
    const { data } = await AxiosInstance.get("/preffer_partner");
    console.log("API Response:", data);

    // Ensure we always return an array
    return data?.prefferPartners || [];
  } catch (error) {
    console.error(
      "Error fetching preferred partners:",
      error.response?.data || error.message
    );

    // Fallback data
    return [
      {
        _id: "1",
        partner_name: "Sample Hotel Partner 1",
        image: "/assets/images/placeholder.jpg",
      },
      {
        _id: "2",
        partner_name: "Sample Hotel Partner 2",
        image: "/assets/images/placeholder.jpg",
      },
    ];
  }
};
